module.exports = __webpack_public_path__ + "img/project_bg4.5c9eed37.png";